
import React from "react"
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Container, Grid, Header, List, Segment } from "semantic-ui-react";
import MenuHeader from '../navbar.jsx';
import DisplayMessage from "../../commons/displayMessage.jsx";
import { Icon } from 'semantic-ui-react'
import PageHeader from "../PageHeader.jsx";
import { BrowserRouter as Router } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Knowrights from '../../../images/Know your Rights.svg'
import Symbole from '../../../images/Symbol.svg'
import cookie from '../../../images/cookie.svg'
import ThirdParty from '../../../images/Third Party.svg'
import settingsmulti from '../../../images/How we use your Data.svg'
import Footer from "../footer.jsx";
function PrivacyPolicyPage() {
  const { t } = useTranslation()
  const cardStyle = {
    height: "100%",
    borderRadius: "7px",
    padding: "17px",
  };
  const iconStyle = {
    marginBottom: "10px",
  };

  return (
    <>
      <Grid>
        <Grid.Column width={16} className="pb-0">
          <MenuHeader />
        </Grid.Column>
      </Grid>
      <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <PageHeader />
        {/* <DisplayMessage context={this} messageType={this.state.messageType} messageHeader={this.state.messageHeader} message={this.state.message} /> */}
        {/* Top Content */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <Header as="h1">Your Privacy at a Glance</Header>

          <p
            style={{
              maxWidth: "850px",
              margin: "15px auto",
              color: "#666",
              lineHeight: "28px",
              fontSize: "16px"
            }}
          >
            Hello! Welcome to the DCN.scot privacy policy.
            We want to make it easy for you to understand how we
            handle your information. Here's a quick overview of
            how we protect your data and respect your privacy.
          </p>
        </div>

        <Grid stackable columns={2}>
          {/* Card 1 */}
          <Grid.Column>
            <Segment raised style={cardStyle}>

              <div style={{ textAlign: "center" }}>
                <img
                  src={Symbole}
                  alt="Settings"
                  style={{ marginBottom: '8px' }}
                />
                <Header as="h2" style={{ marginTop: '0px' }}>
                  Types of data we collect
                </Header>
              </div>
              <List bulleted>
                <List.Item>
                  Personal data you give us when you register
                  for an account
                </List.Item>

                <List.Item>
                  Personal data you give us when you raise a
                  query with us
                </List.Item>

                <List.Item>
                  Personal data we collect about you when you
                  use the service
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>
              <div style={{ textAlign: "center" }}>
                <img
                  src={cookie}
                  alt="Settings"
                  style={{ marginBottom: '8px' }}
                />
                <Header as="h2" style={{ marginTop: '0px' }}>
                  We use cookies...mmm cookie, not that kind
                </Header>
              </div>
              <List bulleted>
                <List.Item>
                  We use necessary cookies to run and secure
                  the service
                </List.Item>

                <List.Item>
                  Cookies help protect your account and improve
                  performance
                </List.Item>

                <List.Item>
                  Cookies do not personally identify you on
                  their own
                </List.Item>

                <List.Item>
                  You can block cookies, but parts of the
                  service may not work
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>

              <div style={{ textAlign: "center" }}>
                <img
                  src={Knowrights}
                  alt="Settings"
                  style={{ marginBottom: '8px' }}
                />
                <Header as="h2" style={{ marginTop: '0px' }}>
                  Know your rights
                </Header>
              </div>

              <List bulleted>
                <List.Item>
                  Access the information we hold about you
                </List.Item>

                <List.Item>
                  Correct or update your details
                </List.Item>

                <List.Item>
                  Close your account and request deletion of
                  your data
                </List.Item>

                <List.Item>
                  Restrict or object to how your data is
                  processed
                </List.Item>

                <List.Item>
                  Request deletion in line with Data Retention
                  Policy
                </List.Item>

                <List.Item>
                  Raise a complaint with the ICO
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>
              <div style={{ textAlign: "center" }}>
                <img
                  src={ThirdParty}
                  alt="Settings"
                  style={{ marginBottom: '8px' }}
                />
                <Header as="h2" style={{ marginTop: '0px' }}>
                  Third parties who process your data
                </Header>
              </div>
              <List bulleted>
                <List.Item>
                  <strong>Infrastructure:</strong>{" "}
                  brightsolid UK, Tata Consultancy Services
                </List.Item>

                <List.Item>
                  <strong>Service providers:</strong>{" "}
                  Local Authorities and Police Scotland
                  (for DCN access and query resolution).
                  Data is shared only where required
                  and under contract.
                </List.Item>

                <List.Item>
                  <strong>Security & fraud prevention:</strong>{" "}
                  where legally required
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment raised style={cardStyle}>
              <div style={{ textAlign: "center" }}>
                <img
                  src={settingsmulti}
                  alt="Settings"
                  style={{ marginBottom: '8px' }}
                />
                <Header as="h2" style={{ marginTop: '0px' }}>
                  How we use your data
                </Header>
              </div>
              <List bulleted >
                <List.Item>
                  To operate and maintain the DCN database.
                </List.Item>

                <List.Item>
                  To allow authorised officers to update,
                  suspend, transfer or discharge DCNs
                </List.Item>

                <List.Item>
                  To provide user support and respond to
                  queries
                </List.Item>

                <List.Item>
                  To develop and improve the services that
                  we offer
                </List.Item>

                <List.Item>
                  Keep the service secure and reliable
                </List.Item>
              </List>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment raised style={cardStyle}>
              <Grid>
                {/* Left */}
                <Grid.Column width={3}>
                  <div style={{ textAlign: "center" }}>
                    <h4 style={{ color: "green" }}>
                      Data You
                      <br />
                      Give
                    </h4>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "18px",
                        position: "relative",
                        marginTop: "46px"
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          width: "2px",
                          background: "green",
                          top: -39,
                          bottom: -10,
                        }}
                      />

                      {[1, 2, 3, 4, 5].map((item) => (
                        <div
                          key={item}
                          style={{
                            width: "20px",
                            height: "20px",
                            border: "2px solid green",
                            borderRadius: "50%",
                            background: "white",
                            zIndex: 1,
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </Grid.Column>

                {/* Middle */}
                <Grid.Column width={3}>
                  <div style={{ textAlign: "center" }}>
                    <h4 style={{ color: "#2185d0" }}>
                      Data We
                      <br />
                      Collect
                    </h4>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "13px",
                        position: "relative",
                        marginTop: "37px"
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          width: "2px",
                          background: "#2185d0",
                          top: -34,
                          bottom: -10,
                        }}
                      />

                      {[1, 2, 3, 4, 5, 6].map((item) => (
                        <div
                          key={item}
                          style={{
                            width: "20px",
                            height: "20px",
                            border: "2px solid #2185d0",
                            borderRadius: "50%",
                            background: "white",
                            zIndex: 1,
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </Grid.Column>
                {/* Right */}
                <Grid.Column width={10}>
                  <List bulleted style={{ marginTop: "50px" }}>
                    <List.Item>
                       You are registered for a DCN agent account
                    </List.Item>

                    <List.Item>
                      You sign in to dcn.scot
                    </List.Item>

                    <List.Item>
                      You use the dcn.scot service
                    </List.Item>

                    <List.Item>
                      You process data
                    </List.Item>

                    <List.Item>
                      You access the service using any device
                    </List.Item>

                    <List.Item>
                      You raise a support request
                    </List.Item>
                  </List>
                </Grid.Column>
              </Grid>
            </Segment>
          </Grid.Column>

        </Grid>


        <Segment
          //padded="very"
          style={{
            textAlign: 'center',
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          }}
        >
          <p style={{ fontWeight: 500 }}>
            Want to know more?{" "}
            <Link className='customLink' to="/privacyPolicy">Read the policy here</Link>
          </p>
        </Segment>


        <Segment
          //padded="very"
          style={{
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
          }}
        >
          <p style={{ fontSize: '16px' }}>
            If you have any concerns about your privacy at{" "}
            <span style={{ fontWeight: 500 }}>
              DCN.scot
            </span>, please email us at{" "}

            <a
              href="mailto:digitalpublicservices@improvementservice.org.uk"
              style={{
                color: '#2185d0',
                fontWeight: 500,
                textDecoration: 'none'
              }}
            >
              digitalpublicservices@improvementservice.org.uk
            </a>{" "}

            or raise a query through our helpdesk.
          </p>
        </Segment>


        <Footer />
      </Container >
    </>
  )
}

export default PrivacyPolicyPage